module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/is-pure.js
// module id = 16
// module chunks = 0